import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.MODE || "development",

  // Performance Monitoring
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,

  // Capture Console
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Capture 10% of all sessions in production
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Session Replay Sample Rates
  replaysSessionSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Error filtering
  beforeSend(event, hint) {
    // In development, log to console for debugging but still send to Sentry
    if (import.meta.env.MODE === "development") {
      console.group("🔍 Sentry Error (Development)");
      console.error("Error:", event);
      console.error("Hint:", hint);
      console.groupEnd();
    }
    return event;
  },

  // Add user context
  initialScope: {
    tags: {
      component: "frontend",
    },
  },
});
